// -- == //
import { Formik } from 'formik';
import React from 'react';

import { ValidationCreateFloor } from 'common/validations';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';
import TextIput from 'components/form/textInput';
import { useActions } from 'common/hooks/useActions';

import * as S from './styles';
import * as T from 'common/types';

interface IProps {
  data?: T.Pages.FloorListItem;
  closeModal?: () => void;
  fetchData?: () => void;
}

const CafeteriaCreateForm: React.FC<IProps> = ({ data, closeModal, fetchData }) => {
  const { floorCreateRequestAction, floorEditRequestAction } = useActions();

  return (
    <Formik
      initialValues={{
        name: data?.name || '',
        id: data?.id || undefined
      }}
      enableReinitialize
      validationSchema={!data?.id ? ValidationCreateFloor : ''}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        if (data?.id)
          floorEditRequestAction(
            {
              name: JSON.stringify(values.name),
              id: data?.id
            },
            () => {
              closeModal && closeModal();
              resetForm();
              fetchData && fetchData();
            }
          );
        else
          floorCreateRequestAction(
            {
              name: JSON.stringify(values.name)
            },
            () => {
              closeModal && closeModal();
              resetForm();
              fetchData && fetchData();
            }
          );
        setSubmitting(false);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <>
          {/*
           * The field had no label — just a `Title` placeholder in a 40px box
           * with its own 7px radius, so the one thing this dialog asks for was
           * unnamed the moment anyone typed into it. It is the design's
           * labelled control now, at the shared height, and it wires
           * handleBlur so the required error can appear before a submit.
           */}
          <TextIput
            type="number"
            name="name"
            label="Floor number"
            required
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="e.g. 2"
            value={values.name}
            message={touched.name && errors.name}
            error={touched.name && (errors.name as unknown as boolean)}
          />

          <S.Actions>
            <OutlineButton onClick={closeModal}>Cancel</OutlineButton>
            <PrimaryButton onClick={handleSubmit}>{data?.id ? 'Save floor' : 'Create floor'}</PrimaryButton>
          </S.Actions>
        </>
      )}
    </Formik>
  );
};

export default CafeteriaCreateForm;
